import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import LandingPage from './figma-to-code-landing-yellow';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LandingPage />
  </React.StrictMode>
);